import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { getChat } from '../../../../../crud/chat.crud';
import ChatSocket from '../../../../../utils/socket';
import { TChannel } from '../../../../../interfaces/chat';
import { getResponseMessage } from '../../../../../utils/utils';

export const useCreateChat: any = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<any>(null);
  const [success, setSuccess] = useState(false);
  const [createdChat, setCreatedChat] = useState<TChannel | null>(null);

  const fetch = useCallback(async (id: any) => {
    if (!ChatSocket.myAuthToken) await ChatSocket.getMyAuthToken();
    setLoading(true);
    getChat(id)
      .then(({ data }) => {
        if (id.companyId) {
          setCreatedChat(data.data)
        } else if (id.userId && !id.companyId) {
          setCreatedChat(data.data)
        }
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
        setErr(null);
        setSuccess(false);
      });
  }, []);

  // useEffect(() => {
  //   if (chats && createdChatCompany) {
  //     const channel = chats.find(
  //       (chat: TChannel) => chat.company?.id === createdChatCompany.id
  //     );
  //     channel && setCreatedChat(channel);
  //   }
  //   if (chats && createdChatUser && createdChatCompany === null) {
  //     const channel = chats.find(
  //       (chat: TChannel) => chat.user?.id === createdChatUser.id
  //     );
  //     channel && setCreatedChat(channel);
  //   }
  // }, [chats, createdChatCompany, createdChatUser]);


  return [fetch, loading, createdChat];
};
